/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CascadeDropdownRequestDTO,
  LocationDTO,
  LocationHierarchyDTO,
  LocationValidationRequestDTO,
  SearchLocationsParams,
  SimulateLocation200,
  SimulateLocationParams,
  ValidateLocationSelectionParams,
  ValidationResultDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Validate location selection against configuration
 */
export const validateLocationSelection = (
    locationValidationRequestDTO: LocationValidationRequestDTO,
    params: ValidateLocationSelectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ValidationResultDTO>(
      {url: `/api/v1/locations/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: locationValidationRequestDTO,
        params, signal
    },
      options);
    }
  


export const getValidateLocationSelectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateLocationSelection>>, TError,{data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateLocationSelection>>, TError,{data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams}, TContext> => {

const mutationKey = ['validateLocationSelection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateLocationSelection>>, {data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams}> = (props) => {
          const {data,params} = props ?? {};

          return  validateLocationSelection(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateLocationSelectionMutationResult = NonNullable<Awaited<ReturnType<typeof validateLocationSelection>>>
    export type ValidateLocationSelectionMutationBody = LocationValidationRequestDTO
    export type ValidateLocationSelectionMutationError = unknown

    /**
 * @summary Validate location selection against configuration
 */
export const useValidateLocationSelection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateLocationSelection>>, TError,{data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateLocationSelection>>,
        TError,
        {data: LocationValidationRequestDTO;params: ValidateLocationSelectionParams},
        TContext
      > => {

      const mutationOptions = getValidateLocationSelectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Generate sample location data based on configuration
 */
export const simulateLocation = (
    params: SimulateLocationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SimulateLocation200>(
      {url: `/api/v1/locations/simulate`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getSimulateLocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simulateLocation>>, TError,{params: SimulateLocationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof simulateLocation>>, TError,{params: SimulateLocationParams}, TContext> => {

const mutationKey = ['simulateLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof simulateLocation>>, {params: SimulateLocationParams}> = (props) => {
          const {params} = props ?? {};

          return  simulateLocation(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SimulateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof simulateLocation>>>
    
    export type SimulateLocationMutationError = unknown

    /**
 * @summary Generate sample location data based on configuration
 */
export const useSimulateLocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof simulateLocation>>, TError,{params: SimulateLocationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof simulateLocation>>,
        TError,
        {params: SimulateLocationParams},
        TContext
      > => {

      const mutationOptions = getSimulateLocationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get locations for cascading dropdown
 */
export const getCascadeLocations = (
    cascadeDropdownRequestDTO: CascadeDropdownRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/cascade`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cascadeDropdownRequestDTO, signal
    },
      options);
    }
  


export const getGetCascadeLocationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCascadeLocations>>, TError,{data: CascadeDropdownRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getCascadeLocations>>, TError,{data: CascadeDropdownRequestDTO}, TContext> => {

const mutationKey = ['getCascadeLocations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCascadeLocations>>, {data: CascadeDropdownRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  getCascadeLocations(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetCascadeLocationsMutationResult = NonNullable<Awaited<ReturnType<typeof getCascadeLocations>>>
    export type GetCascadeLocationsMutationBody = CascadeDropdownRequestDTO
    export type GetCascadeLocationsMutationError = unknown

    /**
 * @summary Get locations for cascading dropdown
 */
export const useGetCascadeLocations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCascadeLocations>>, TError,{data: CascadeDropdownRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCascadeLocations>>,
        TError,
        {data: CascadeDropdownRequestDTO},
        TContext
      > => {

      const mutationOptions = getGetCascadeLocationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all zones
 */
export const getLocationZones = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/zones`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLocationZonesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/locations/zones`
    ] as const;
    }

export const getGetLocationZonesQueryKey = () => {
    return [
    `/api/v1/locations/zones`
    ] as const;
    }

    
export const getGetLocationZonesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLocationZones>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationZonesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationZones>>> = ({ signal }) => getLocationZones(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationZonesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationZones>>>
export type GetLocationZonesInfiniteQueryError = unknown


export function useGetLocationZonesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationZones>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationZones>>,
          TError,
          Awaited<ReturnType<typeof getLocationZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationZonesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationZones>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationZones>>,
          TError,
          Awaited<ReturnType<typeof getLocationZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationZonesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationZones>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all zones
 */

export function useGetLocationZonesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationZones>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationZonesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLocationZonesQueryOptions = <TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationZonesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationZones>>> = ({ signal }) => getLocationZones(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationZonesQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationZones>>>
export type GetLocationZonesQueryError = unknown


export function useGetLocationZones<TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationZones>>,
          TError,
          Awaited<ReturnType<typeof getLocationZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationZones<TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationZones>>,
          TError,
          Awaited<ReturnType<typeof getLocationZones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationZones<TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all zones
 */

export function useGetLocationZones<TData = Awaited<ReturnType<typeof getLocationZones>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationZones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationZonesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get regions by zone
 */
export const getRegionsByZone = (
    zoneId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/zones/${zoneId}/regions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetRegionsByZoneInfiniteQueryKey = (zoneId?: number,) => {
    return [
    'infinite', `/api/v1/locations/zones/${zoneId}/regions`
    ] as const;
    }

export const getGetRegionsByZoneQueryKey = (zoneId?: number,) => {
    return [
    `/api/v1/locations/zones/${zoneId}/regions`
    ] as const;
    }

    
export const getGetRegionsByZoneInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getRegionsByZone>>>, TError = unknown>(zoneId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegionsByZoneInfiniteQueryKey(zoneId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegionsByZone>>> = ({ signal }) => getRegionsByZone(zoneId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(zoneId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRegionsByZoneInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRegionsByZone>>>
export type GetRegionsByZoneInfiniteQueryError = unknown


export function useGetRegionsByZoneInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRegionsByZone>>>, TError = unknown>(
 zoneId: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegionsByZone>>,
          TError,
          Awaited<ReturnType<typeof getRegionsByZone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegionsByZoneInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRegionsByZone>>>, TError = unknown>(
 zoneId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegionsByZone>>,
          TError,
          Awaited<ReturnType<typeof getRegionsByZone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegionsByZoneInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRegionsByZone>>>, TError = unknown>(
 zoneId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get regions by zone
 */

export function useGetRegionsByZoneInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRegionsByZone>>>, TError = unknown>(
 zoneId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRegionsByZoneInfiniteQueryOptions(zoneId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetRegionsByZoneQueryOptions = <TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegionsByZoneQueryKey(zoneId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegionsByZone>>> = ({ signal }) => getRegionsByZone(zoneId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(zoneId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRegionsByZoneQueryResult = NonNullable<Awaited<ReturnType<typeof getRegionsByZone>>>
export type GetRegionsByZoneQueryError = unknown


export function useGetRegionsByZone<TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(
 zoneId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegionsByZone>>,
          TError,
          Awaited<ReturnType<typeof getRegionsByZone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegionsByZone<TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(
 zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegionsByZone>>,
          TError,
          Awaited<ReturnType<typeof getRegionsByZone>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRegionsByZone<TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(
 zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get regions by zone
 */

export function useGetRegionsByZone<TData = Awaited<ReturnType<typeof getRegionsByZone>>, TError = unknown>(
 zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegionsByZone>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRegionsByZoneQueryOptions(zoneId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get streets by ward
 */
export const getStreetsByWard1 = (
    wardId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/wards/${wardId}/streets`, method: 'GET', signal
    },
      options);
    }
  



export const getGetStreetsByWard1InfiniteQueryKey = (wardId?: number,) => {
    return [
    'infinite', `/api/v1/locations/wards/${wardId}/streets`
    ] as const;
    }

export const getGetStreetsByWard1QueryKey = (wardId?: number,) => {
    return [
    `/api/v1/locations/wards/${wardId}/streets`
    ] as const;
    }

    
export const getGetStreetsByWard1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getStreetsByWard1>>>, TError = unknown>(wardId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreetsByWard1InfiniteQueryKey(wardId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreetsByWard1>>> = ({ signal }) => getStreetsByWard1(wardId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(wardId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetStreetsByWard1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getStreetsByWard1>>>
export type GetStreetsByWard1InfiniteQueryError = unknown


export function useGetStreetsByWard1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getStreetsByWard1>>>, TError = unknown>(
 wardId: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreetsByWard1>>,
          TError,
          Awaited<ReturnType<typeof getStreetsByWard1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStreetsByWard1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getStreetsByWard1>>>, TError = unknown>(
 wardId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreetsByWard1>>,
          TError,
          Awaited<ReturnType<typeof getStreetsByWard1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStreetsByWard1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getStreetsByWard1>>>, TError = unknown>(
 wardId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get streets by ward
 */

export function useGetStreetsByWard1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getStreetsByWard1>>>, TError = unknown>(
 wardId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetStreetsByWard1InfiniteQueryOptions(wardId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetStreetsByWard1QueryOptions = <TData = Awaited<ReturnType<typeof getStreetsByWard1>>, TError = unknown>(wardId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreetsByWard1QueryKey(wardId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreetsByWard1>>> = ({ signal }) => getStreetsByWard1(wardId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(wardId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetStreetsByWard1QueryResult = NonNullable<Awaited<ReturnType<typeof getStreetsByWard1>>>
export type GetStreetsByWard1QueryError = unknown


export function useGetStreetsByWard1<TData = Awaited<ReturnType<typeof getStreetsByWard1>>, TError = unknown>(
 wardId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreetsByWard1>>,
          TError,
          Awaited<ReturnType<typeof getStreetsByWard1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStreetsByWard1<TData = Awaited<ReturnType<typeof getStreetsByWard1>>, TError = unknown>(
 wardId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreetsByWard1>>,
          TError,
          Awaited<ReturnType<typeof getStreetsByWard1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStreetsByWard1<TData = Awaited<ReturnType<typeof getStreetsByWard1>>, TError = unknown>(
 wardId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get streets by ward
 */

export function useGetStreetsByWard1<TData = Awaited<ReturnType<typeof getStreetsByWard1>>, TError = unknown>(
 wardId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetsByWard1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetStreetsByWard1QueryOptions(wardId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Search locations by name and directory
 */
export const searchLocations = (
    params: SearchLocationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/search`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchLocationsInfiniteQueryKey = (params?: SearchLocationsParams,) => {
    return [
    'infinite', `/api/v1/locations/search`, ...(params ? [params]: [])
    ] as const;
    }

export const getSearchLocationsQueryKey = (params?: SearchLocationsParams,) => {
    return [
    `/api/v1/locations/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchLocationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchLocations>>>, TError = unknown>(params: SearchLocationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchLocationsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchLocations>>> = ({ signal }) => searchLocations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchLocationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchLocations>>>
export type SearchLocationsInfiniteQueryError = unknown


export function useSearchLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchLocations>>>, TError = unknown>(
 params: SearchLocationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLocations>>,
          TError,
          Awaited<ReturnType<typeof searchLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchLocations>>>, TError = unknown>(
 params: SearchLocationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLocations>>,
          TError,
          Awaited<ReturnType<typeof searchLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchLocations>>>, TError = unknown>(
 params: SearchLocationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search locations by name and directory
 */

export function useSearchLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchLocations>>>, TError = unknown>(
 params: SearchLocationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchLocationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchLocationsQueryOptions = <TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(params: SearchLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchLocationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchLocations>>> = ({ signal }) => searchLocations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof searchLocations>>>
export type SearchLocationsQueryError = unknown


export function useSearchLocations<TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(
 params: SearchLocationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLocations>>,
          TError,
          Awaited<ReturnType<typeof searchLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLocations<TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(
 params: SearchLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchLocations>>,
          TError,
          Awaited<ReturnType<typeof searchLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchLocations<TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(
 params: SearchLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search locations by name and directory
 */

export function useSearchLocations<TData = Awaited<ReturnType<typeof searchLocations>>, TError = unknown>(
 params: SearchLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get all regions
 */
export const getLocationRegions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/regions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLocationRegionsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/locations/regions`
    ] as const;
    }

export const getGetLocationRegionsQueryKey = () => {
    return [
    `/api/v1/locations/regions`
    ] as const;
    }

    
export const getGetLocationRegionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLocationRegions>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationRegionsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationRegions>>> = ({ signal }) => getLocationRegions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationRegionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationRegions>>>
export type GetLocationRegionsInfiniteQueryError = unknown


export function useGetLocationRegionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationRegions>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationRegions>>,
          TError,
          Awaited<ReturnType<typeof getLocationRegions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationRegionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationRegions>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationRegions>>,
          TError,
          Awaited<ReturnType<typeof getLocationRegions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationRegionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationRegions>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all regions
 */

export function useGetLocationRegionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationRegions>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationRegionsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLocationRegionsQueryOptions = <TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationRegionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationRegions>>> = ({ signal }) => getLocationRegions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationRegionsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationRegions>>>
export type GetLocationRegionsQueryError = unknown


export function useGetLocationRegions<TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationRegions>>,
          TError,
          Awaited<ReturnType<typeof getLocationRegions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationRegions<TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationRegions>>,
          TError,
          Awaited<ReturnType<typeof getLocationRegions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationRegions<TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all regions
 */

export function useGetLocationRegions<TData = Awaited<ReturnType<typeof getLocationRegions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationRegions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationRegionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get districts by region
 */
export const getDistrictsByRegion1 = (
    regionId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/regions/${regionId}/districts`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDistrictsByRegion1InfiniteQueryKey = (regionId?: number,) => {
    return [
    'infinite', `/api/v1/locations/regions/${regionId}/districts`
    ] as const;
    }

export const getGetDistrictsByRegion1QueryKey = (regionId?: number,) => {
    return [
    `/api/v1/locations/regions/${regionId}/districts`
    ] as const;
    }

    
export const getGetDistrictsByRegion1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDistrictsByRegion1>>>, TError = unknown>(regionId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDistrictsByRegion1InfiniteQueryKey(regionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDistrictsByRegion1>>> = ({ signal }) => getDistrictsByRegion1(regionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(regionId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDistrictsByRegion1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDistrictsByRegion1>>>
export type GetDistrictsByRegion1InfiniteQueryError = unknown


export function useGetDistrictsByRegion1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getDistrictsByRegion1>>>, TError = unknown>(
 regionId: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistrictsByRegion1>>,
          TError,
          Awaited<ReturnType<typeof getDistrictsByRegion1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDistrictsByRegion1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getDistrictsByRegion1>>>, TError = unknown>(
 regionId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistrictsByRegion1>>,
          TError,
          Awaited<ReturnType<typeof getDistrictsByRegion1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDistrictsByRegion1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getDistrictsByRegion1>>>, TError = unknown>(
 regionId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get districts by region
 */

export function useGetDistrictsByRegion1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getDistrictsByRegion1>>>, TError = unknown>(
 regionId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDistrictsByRegion1InfiniteQueryOptions(regionId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDistrictsByRegion1QueryOptions = <TData = Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError = unknown>(regionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDistrictsByRegion1QueryKey(regionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDistrictsByRegion1>>> = ({ signal }) => getDistrictsByRegion1(regionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(regionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDistrictsByRegion1QueryResult = NonNullable<Awaited<ReturnType<typeof getDistrictsByRegion1>>>
export type GetDistrictsByRegion1QueryError = unknown


export function useGetDistrictsByRegion1<TData = Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError = unknown>(
 regionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistrictsByRegion1>>,
          TError,
          Awaited<ReturnType<typeof getDistrictsByRegion1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDistrictsByRegion1<TData = Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError = unknown>(
 regionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDistrictsByRegion1>>,
          TError,
          Awaited<ReturnType<typeof getDistrictsByRegion1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDistrictsByRegion1<TData = Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError = unknown>(
 regionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get districts by region
 */

export function useGetDistrictsByRegion1<TData = Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError = unknown>(
 regionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDistrictsByRegion1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDistrictsByRegion1QueryOptions(regionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get complete location hierarchy for a location
 */
export const getLocationHierarchy = (
    locationId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationHierarchyDTO>(
      {url: `/api/v1/locations/hierarchy/${locationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLocationHierarchyInfiniteQueryKey = (locationId?: number,) => {
    return [
    'infinite', `/api/v1/locations/hierarchy/${locationId}`
    ] as const;
    }

export const getGetLocationHierarchyQueryKey = (locationId?: number,) => {
    return [
    `/api/v1/locations/hierarchy/${locationId}`
    ] as const;
    }

    
export const getGetLocationHierarchyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLocationHierarchy>>>, TError = unknown>(locationId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationHierarchyInfiniteQueryKey(locationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationHierarchy>>> = ({ signal }) => getLocationHierarchy(locationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locationId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationHierarchyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationHierarchy>>>
export type GetLocationHierarchyInfiniteQueryError = unknown


export function useGetLocationHierarchyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationHierarchy>>>, TError = unknown>(
 locationId: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationHierarchy>>,
          TError,
          Awaited<ReturnType<typeof getLocationHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationHierarchyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationHierarchy>>>, TError = unknown>(
 locationId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationHierarchy>>,
          TError,
          Awaited<ReturnType<typeof getLocationHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationHierarchyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationHierarchy>>>, TError = unknown>(
 locationId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get complete location hierarchy for a location
 */

export function useGetLocationHierarchyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationHierarchy>>>, TError = unknown>(
 locationId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationHierarchyInfiniteQueryOptions(locationId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLocationHierarchyQueryOptions = <TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationHierarchyQueryKey(locationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationHierarchy>>> = ({ signal }) => getLocationHierarchy(locationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(locationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationHierarchyQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationHierarchy>>>
export type GetLocationHierarchyQueryError = unknown


export function useGetLocationHierarchy<TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationHierarchy>>,
          TError,
          Awaited<ReturnType<typeof getLocationHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationHierarchy<TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationHierarchy>>,
          TError,
          Awaited<ReturnType<typeof getLocationHierarchy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationHierarchy<TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get complete location hierarchy for a location
 */

export function useGetLocationHierarchy<TData = Awaited<ReturnType<typeof getLocationHierarchy>>, TError = unknown>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationHierarchy>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationHierarchyQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get wards by district
 */
export const getWardsByDistrict1 = (
    districtId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/districts/${districtId}/wards`, method: 'GET', signal
    },
      options);
    }
  



export const getGetWardsByDistrict1InfiniteQueryKey = (districtId?: number,) => {
    return [
    'infinite', `/api/v1/locations/districts/${districtId}/wards`
    ] as const;
    }

export const getGetWardsByDistrict1QueryKey = (districtId?: number,) => {
    return [
    `/api/v1/locations/districts/${districtId}/wards`
    ] as const;
    }

    
export const getGetWardsByDistrict1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getWardsByDistrict1>>>, TError = unknown>(districtId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWardsByDistrict1InfiniteQueryKey(districtId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWardsByDistrict1>>> = ({ signal }) => getWardsByDistrict1(districtId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(districtId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWardsByDistrict1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getWardsByDistrict1>>>
export type GetWardsByDistrict1InfiniteQueryError = unknown


export function useGetWardsByDistrict1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getWardsByDistrict1>>>, TError = unknown>(
 districtId: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWardsByDistrict1>>,
          TError,
          Awaited<ReturnType<typeof getWardsByDistrict1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWardsByDistrict1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getWardsByDistrict1>>>, TError = unknown>(
 districtId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWardsByDistrict1>>,
          TError,
          Awaited<ReturnType<typeof getWardsByDistrict1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWardsByDistrict1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getWardsByDistrict1>>>, TError = unknown>(
 districtId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get wards by district
 */

export function useGetWardsByDistrict1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getWardsByDistrict1>>>, TError = unknown>(
 districtId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWardsByDistrict1InfiniteQueryOptions(districtId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetWardsByDistrict1QueryOptions = <TData = Awaited<ReturnType<typeof getWardsByDistrict1>>, TError = unknown>(districtId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWardsByDistrict1QueryKey(districtId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWardsByDistrict1>>> = ({ signal }) => getWardsByDistrict1(districtId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(districtId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWardsByDistrict1QueryResult = NonNullable<Awaited<ReturnType<typeof getWardsByDistrict1>>>
export type GetWardsByDistrict1QueryError = unknown


export function useGetWardsByDistrict1<TData = Awaited<ReturnType<typeof getWardsByDistrict1>>, TError = unknown>(
 districtId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWardsByDistrict1>>,
          TError,
          Awaited<ReturnType<typeof getWardsByDistrict1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWardsByDistrict1<TData = Awaited<ReturnType<typeof getWardsByDistrict1>>, TError = unknown>(
 districtId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWardsByDistrict1>>,
          TError,
          Awaited<ReturnType<typeof getWardsByDistrict1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWardsByDistrict1<TData = Awaited<ReturnType<typeof getWardsByDistrict1>>, TError = unknown>(
 districtId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get wards by district
 */

export function useGetWardsByDistrict1<TData = Awaited<ReturnType<typeof getWardsByDistrict1>>, TError = unknown>(
 districtId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWardsByDistrict1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWardsByDistrict1QueryOptions(districtId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get locations by directory ID
 */
export const getLocationsByDirectory = (
    directoryId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/directory/${directoryId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLocationsByDirectoryInfiniteQueryKey = (directoryId?: number,) => {
    return [
    'infinite', `/api/v1/locations/directory/${directoryId}`
    ] as const;
    }

export const getGetLocationsByDirectoryQueryKey = (directoryId?: number,) => {
    return [
    `/api/v1/locations/directory/${directoryId}`
    ] as const;
    }

    
export const getGetLocationsByDirectoryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByDirectory>>>, TError = unknown>(directoryId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsByDirectoryInfiniteQueryKey(directoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationsByDirectory>>> = ({ signal }) => getLocationsByDirectory(directoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(directoryId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationsByDirectoryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationsByDirectory>>>
export type GetLocationsByDirectoryInfiniteQueryError = unknown


export function useGetLocationsByDirectoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByDirectory>>>, TError = unknown>(
 directoryId: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByDirectory>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByDirectory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByDirectoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByDirectory>>>, TError = unknown>(
 directoryId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByDirectory>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByDirectory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByDirectoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByDirectory>>>, TError = unknown>(
 directoryId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get locations by directory ID
 */

export function useGetLocationsByDirectoryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByDirectory>>>, TError = unknown>(
 directoryId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationsByDirectoryInfiniteQueryOptions(directoryId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLocationsByDirectoryQueryOptions = <TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(directoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsByDirectoryQueryKey(directoryId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationsByDirectory>>> = ({ signal }) => getLocationsByDirectory(directoryId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(directoryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationsByDirectoryQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationsByDirectory>>>
export type GetLocationsByDirectoryQueryError = unknown


export function useGetLocationsByDirectory<TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(
 directoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByDirectory>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByDirectory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByDirectory<TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(
 directoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByDirectory>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByDirectory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByDirectory<TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(
 directoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get locations by directory ID
 */

export function useGetLocationsByDirectory<TData = Awaited<ReturnType<typeof getLocationsByDirectory>>, TError = unknown>(
 directoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByDirectory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationsByDirectoryQueryOptions(directoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get root level locations (zones)
 */
export const getRootLocations = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/children`, method: 'GET', signal
    },
      options);
    }
  



export const getGetRootLocationsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/locations/children`
    ] as const;
    }

export const getGetRootLocationsQueryKey = () => {
    return [
    `/api/v1/locations/children`
    ] as const;
    }

    
export const getGetRootLocationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getRootLocations>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRootLocationsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRootLocations>>> = ({ signal }) => getRootLocations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRootLocationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRootLocations>>>
export type GetRootLocationsInfiniteQueryError = unknown


export function useGetRootLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRootLocations>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootLocations>>,
          TError,
          Awaited<ReturnType<typeof getRootLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRootLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRootLocations>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootLocations>>,
          TError,
          Awaited<ReturnType<typeof getRootLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRootLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRootLocations>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get root level locations (zones)
 */

export function useGetRootLocationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getRootLocations>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRootLocationsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetRootLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRootLocationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRootLocations>>> = ({ signal }) => getRootLocations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRootLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getRootLocations>>>
export type GetRootLocationsQueryError = unknown


export function useGetRootLocations<TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootLocations>>,
          TError,
          Awaited<ReturnType<typeof getRootLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRootLocations<TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRootLocations>>,
          TError,
          Awaited<ReturnType<typeof getRootLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRootLocations<TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get root level locations (zones)
 */

export function useGetRootLocations<TData = Awaited<ReturnType<typeof getRootLocations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRootLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRootLocationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get child locations by parent ID
 */
export const getLocationsByParentId = (
    parentId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocationDTO[]>(
      {url: `/api/v1/locations/children/${parentId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLocationsByParentIdInfiniteQueryKey = (parentId?: number,) => {
    return [
    'infinite', `/api/v1/locations/children/${parentId}`
    ] as const;
    }

export const getGetLocationsByParentIdQueryKey = (parentId?: number,) => {
    return [
    `/api/v1/locations/children/${parentId}`
    ] as const;
    }

    
export const getGetLocationsByParentIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByParentId>>>, TError = unknown>(parentId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsByParentIdInfiniteQueryKey(parentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationsByParentId>>> = ({ signal }) => getLocationsByParentId(parentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(parentId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationsByParentIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationsByParentId>>>
export type GetLocationsByParentIdInfiniteQueryError = unknown


export function useGetLocationsByParentIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByParentId>>>, TError = unknown>(
 parentId: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByParentId>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByParentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByParentIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByParentId>>>, TError = unknown>(
 parentId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByParentId>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByParentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByParentIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByParentId>>>, TError = unknown>(
 parentId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get child locations by parent ID
 */

export function useGetLocationsByParentIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLocationsByParentId>>>, TError = unknown>(
 parentId: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationsByParentIdInfiniteQueryOptions(parentId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLocationsByParentIdQueryOptions = <TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(parentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsByParentIdQueryKey(parentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocationsByParentId>>> = ({ signal }) => getLocationsByParentId(parentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(parentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLocationsByParentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLocationsByParentId>>>
export type GetLocationsByParentIdQueryError = unknown


export function useGetLocationsByParentId<TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(
 parentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByParentId>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByParentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByParentId<TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(
 parentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocationsByParentId>>,
          TError,
          Awaited<ReturnType<typeof getLocationsByParentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLocationsByParentId<TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(
 parentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get child locations by parent ID
 */

export function useGetLocationsByParentId<TData = Awaited<ReturnType<typeof getLocationsByParentId>>, TError = unknown>(
 parentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocationsByParentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLocationsByParentIdQueryOptions(parentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




